import $ from "jquery";
import c from "common";

var body = document.body || document.documentElement,
  style = body.style,
  vendor = ['Moz', 'Webkit', 'O', 'ms'];

function cssProperty(property) {
  if (typeof style === 'undefined') {
    return false;
  }

  if (typeof style[property] === 'string') {
    return true;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);
  // eslint-disable-next-line no-plusplus
  for (var i = 0; i < vendor.length; i++) {
    if (typeof style[vendor[i] + property] === 'string') {
      return true;
    }
  }
}

function init() {
  var $html = $('html');
  if (cssProperty("animation")) {
    $html.addClass("cssanimation");
  }
  if (cssProperty("transform")) {
    $html.addClass("csstransform");
  }
  if (cssProperty("transition")) {
    $html.addClass("csstransition");
  }
  $html.addClass("js");
}

export default {
  init: c.setup(init),
  isMac: function () {
    return window.navigator && window.navigator.platform && (window.navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false);
  },
  isMobile: function () {
    return window.navigator && window.navigator.platform && (window.navigator.platform.match(/(Android|BlackBerry|iPhone|iPod|iPad|Opera Mini|IEMobile)/i) ? true : false);
  }
};



// WEBPACK FOOTER //
// ./web/js/support.js